module.exports = {"data":{"site":{"siteMetadata":{"title":"SciChess","languages":{"defaultLangKey":"en","langs":["en","is"]},"menu":[{"label":"learn","slug":"/learn"},{"label":"teach","slug":"/teach"},{"label":"about","slug":"/about"},{"label":"helpUs","slug":"/help-us"},{"label":"software","slug":"/softwares"},{"label":"methods","slug":"/methods"}]}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-is.json
// module id = 235
// module chunks = 45593596689585 60335399758886